module.exports = __webpack_public_path__ + "static/img/FinishPlus.161dc1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/FinishPlus.jpg
// module id = 4eYY
// module chunks = 1